"use client";

import type { ColumnFormat, ColumnGroup, FilterClause, SelectList } from "../domain";


export const MAX_CLIENT_ROWS = 5000;
/** Виртуализация включается только для списков длиннее порога (если задан `virtualizeRows`). */
export const VIRTUALIZATION_THRESHOLD = 50;

export function getHeaderText(value: unknown): string | undefined {
  return typeof value === "string" ? value : undefined;
}
export const EMPTY_STRING_ARRAY: string[] = [];
export const EMPTY_COLUMN_GROUPS: ColumnGroup[] = [];
export const EMPTY_COLUMN_META: Record<string, ColumnFormat> = {};
export const EMPTY_LISTS: SelectList[] = [];
export const EMPTY_FILTERS: FilterClause[] = [];

